import { all, call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { generateUrl, getAccessToken, Toast } from '../../utils/helper';
import { clearCookies, clearOldCookies } from '../../utils/helper';
import {
    GET_DASHBOARD_DETAILS,
    GET_NOTIFICATION_LIST,
    READ_NOTIFICATION_LIST,
    CLEAR_NOTIFICATION_LIST,
    GET_INTERVIEW_DETAILS,
    RESEND_EMAIL,
    CHANGE_PASSWORD,
    LOGOUT_USER,
    GET_PLANS_AND_PRICING,
    GET_BILLING_INFORMATION,
    GET_POSITION_LIST,
    GET_MANDATORY_SKILL,
    FETCH_SKILLS_POSITION,
    FETCH_SKILLS_JD,
    POST_CHECKOUT,
    FETCH_RESUME_SCORE,
    GET_USER_INFORMATION,
    UPDATE_USER_INFORMATION,
    SUPPORT_REQUEST,
    GET_SUPPORT_TICKET,
    CLOSE_SUPPORT_TICKET,
    ORDER_UPDATE,
    CREATE_INTERVIEW,
    REPLICATE_INTERVIEW,
    VERIFY_PAYMENT,
    APPLY_COUPON,
    GET_BANNERS,
} from '../action/types';
import {
    getDashboardDetailsSuccess,
    getNotificationSuccess,
    readNotificationSuccess,
    clearNotificationSuccess,
    getInterviewDetailsSuccess,
    resendEmailSuccess,
    changePasswordSuccess,
    logoutUserSuccess,
    getPlansAndPricingListSuccess,
    getBillingInformationSuccess,
    getPositionListSuccess,
    getMandatorySkillSuccess,
    fetchSkillsPositionSuccess,
    fetchSkillsJDSuccess,
    postCheckoutSuccess,
    fetchResumeScoreSuccess,
    getUserInformationSuccess,
    updateUserInformationSuccess,
    supportRequestSuccess,
    getSupportTicketSuccess,
    closeSupportTicketSuccess,
    getDashboardDetailsFailure,
    getNotificationFailure,
    readNotificationFailure,
    clearNotificationFailure,
    getInterviewDetailsFailure,
    resendEmailFailure,
    changePasswordFailure,
    logoutUserFailure,
    getPlansAndPricingListFailure,
    getBillingInformationFailure,
    getPositionListFailure,
    getMandatorySkillFailure,
    fetchSkillsPositionFailure,
    fetchSkillsJDFailure,
    postCheckoutFailure,
    fetchResumeScoreFailure,
    getUserInformationFailure,
    updateUserInformationFailure,
    supportRequestFailure,
    getSupportTicketFailure,
    closeSupportTicketFailure,
    orderUpdateSuccess,
    orderUpdateFailure,
    createInterviewSuccess,
    createInterviewFailure,
    replicateInterviewSuccess,
    replicateInterviewFailure,
    verifyPaymentSuccess,
    verifyPaymentFailure,
    applyCouponSuccess,
    applyCouponFailure,
    getBannersSuccess,
    getBannersFailure,
} from '../action';
import MOCK from '../../utils/api/mock';
import { LOCAL_MOCK_BACKEND } from '../../common/constants';

const handleError = (e) => {
    const errorMessage = e?.response?.data?.message;
    if (errorMessage && errorMessage !== 'Your session has been expired, please login again!') {
        toast.error(<Toast msg={errorMessage} />, {
            autoClose: 5000,
            toastId: errorMessage,
        });
    }
};
const handleLogout = () => {
    localStorage.clear();
    clearCookies();
    clearOldCookies();
    toast.success(<Toast msg="Logged out successfully." />, {
        autoClose: 5000,
        toastId: 'Logged out successfully.',
    });
    window.location.replace(generateUrl('website') + '/candidate/login');
};
function* getPlansAndPricingListRequest(action) {
    try {
        const res = yield MOCK.get(`plans/get-plans/${action?.payload}`);
        if (res.status === 200) yield put(getPlansAndPricingListSuccess(res.data.result));
    } catch (e) {
        yield put(getPlansAndPricingListFailure());
        handleError(e);
    }
}
function* getBillingInformationRequest(action) {
    try {
        const { search, page, pageSize, sort, filter = null, status } = action.payload;
        const isSearch = search ? `&search=${encodeURIComponent(search)}` : '';
        const isPageAndPageSize = page && pageSize ? `?page=${page}&pageSize=${pageSize}` : '';
        const isSort = filter?.sort ? `&sort=${filter.sort}` : sort ? `&sort=${sort}` : '';
        const formatDate = (date) => (date ? date.split('T')[0] : '');

        const isFilter = filter
            ? (filter.status ? `&status=${filter.status}` : status ? `&status=${encodeURIComponent(status)}` : '') +
              (filter.from
                  ? filter.to
                      ? `&from=${formatDate(filter.from)}T00:00:00&to=${formatDate(filter.to)}T23:59:59`
                      : `&from=${formatDate(filter.from)}T00:00:00&to=3000-12-31T23:59:59`
                  : filter.to
                    ? `&from=2000-01-01T00:00:00&to=${formatDate(filter.to)}T23:59:59`
                    : '') +
              (filter.qFrom
                  ? filter.qTo
                      ? `&qFrom=${formatDate(filter.qFrom)}T00:00:00&qTo=${formatDate(filter.qTo)}T23:59:59`
                      : `&qFrom=${formatDate(filter.qFrom)}T00:00:00&qTo=3000-12-31T23:59:59`
                  : filter.qTo
                    ? `&qFrom=2000-01-01T00:00:00&qTo=${formatDate(filter.qTo)}T23:59:59`
                    : '')
            : '';
        const res = yield MOCK.get(`payments/purchaseHistory${isPageAndPageSize}${isSearch}${isFilter}${isSort}`);
        if (res.status === 200) yield put(getBillingInformationSuccess(res.data.result));
    } catch (e) {
        yield put(getBillingInformationFailure());
        handleError(e);
    }
}
function* getDashboardDetailsRequest() {
    try {
        const res = yield MOCK.get('interviews/dashboard-stats');
        if (res.status === 200) yield put(getDashboardDetailsSuccess(res.data.result));
    } catch (e) {
        yield put(getDashboardDetailsFailure());
        handleError(e);
    }
}
function* getNotificationRequest(action) {
    try {
        const isPageAndPageSize =
            action.payload.page && action.payload.pageSize
                ? `?page=${action.payload.page}&pageSize=${action.payload.pageSize}`
                : '';
        const isSearch = action.payload.search ? `&search=${encodeURIComponent(action.payload.search)}` : '';
        const res = yield MOCK.get(`auth/notification${isPageAndPageSize}${isSearch}`);
        if (res.status === 200) yield put(getNotificationSuccess(res.data.result));
    } catch (e) {
        yield put(getNotificationFailure());
    }
}
function* readNotificationRequest() {
    try {
        const res = yield MOCK.put('auth/notification/readAll');
        if ([200, 201].includes(res.status)) yield put(readNotificationSuccess());
    } catch (e) {
        yield put(readNotificationFailure());
    }
}
function* clearNotificationRequest(action) {
    try {
        const res = yield MOCK.delete(`auth/notification/${action.payload.id}`);
        if (res.status === 204) {
            yield put(clearNotificationSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(clearNotificationFailure());
    }
}
function* changePasswordRequest(action) {
    try {
        const res = yield MOCK.post('auth/change-password', action.payload);
        if (res.status === 200) {
            yield put(changePasswordSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(changePasswordFailure());
        handleError(e);
    }
}
function* logoutUserRequest() {
    try {
        const res = yield MOCK.get('auth/logout');
        if (res.status === 200) {
            yield put(logoutUserSuccess());
            handleLogout();
        }
    } catch (e) {
        yield put(logoutUserFailure());
        handleLogout();
    }
}
function* supportRequest(action) {
    const formData = new FormData();
    action.payload.data.desc && formData.append('message', action.payload.data.desc);
    action.payload.data.file && formData.append('file', action.payload.data.file);
    action.payload.data.type && formData.append('type', action.payload.data.type);
    try {
        const res = yield MOCK.post('auth/support', formData);
        if (res.status === 200) {
            yield put(supportRequestSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(supportRequestFailure());
        handleError(e);
    }
}
function* getSupportTicketsRequest(action) {
    const isSearch = action.payload.search ? `&search=${encodeURIComponent(action.payload.search)}` : '';
    const isPageAndPageSize =
        action.payload.page && action.payload.pageSize
            ? `?page=${action.payload.page}&pageSize=${action.payload.pageSize}`
            : '';
    const isSort =
        action.payload.sort && action.payload.order ? `&sort=${action.payload.sort}&order=${action.payload.order}` : '';
    try {
        const res = yield MOCK.get(`auth/support${isPageAndPageSize}${isSort}${isSearch}`);
        if (res.status === 200) yield put(getSupportTicketSuccess(res.data.result));
    } catch (e) {
        yield put(getSupportTicketFailure());
        handleError(e);
    }
}
function* closeSupportTicketRequest(action) {
    try {
        const res = yield MOCK.put(`auth/support/status/${action.payload.id}`);
        if (res.status === 200) {
            yield put(closeSupportTicketSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(closeSupportTicketFailure());
        handleError(e);
    }
}
function* getPositionListRequest() {
    try {
        const res = yield MOCK.get('interviews/get-positions');
        if (res.status === 200) yield put(getPositionListSuccess(res.data.result));
    } catch (e) {
        yield put(getPositionListFailure());
        handleError(e);
    }
}
function* getMandatorySkillRequest() {
    try {
        const res = yield MOCK.get('interviews/globalSkills');
        if (res.status === 200) yield put(getMandatorySkillSuccess(res.data.result));
    } catch (e) {
        yield put(getMandatorySkillFailure());
        handleError(e);
    }
}
function* resendEmailRequest(action) {
    try {
        const res = yield MOCK.get(`interviews/re-invite/${action.payload.interviewId}`);
        if (res.status === 200) {
            yield put(resendEmailSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(resendEmailFailure());
        handleError(e);
    }
}
function* getUserInformationRequest() {
    try {
        const res = yield MOCK.get('auth/user-profile');
        if (res.status === 200) yield put(getUserInformationSuccess(res.data.result));
    } catch (e) {
        yield put(getUserInformationFailure());
        handleError(e);
    }
}
function* updateUserInformationRequest(action) {
    try {
        if (action?.payload?.permissionChange) {
            const res = yield MOCK.post('auth/user-profile/update', { twoFactorEnabled: action?.payload?.status });
            if (res.status === 200) {
                yield put(updateUserInformationSuccess());
                yield call(action.payload.callback());
            }
        } else {
            let resType = typeof action.payload.data?.resume;
            const formData = new FormData();
            formData.append('fullName', action.payload.data?.fullName);
            formData.append('whatsappNumber', action.payload.data?.whatsappNumber);
            if (action.payload.data?.orgName) formData.append('orgName', action.payload.data?.orgName);
            if (action.payload.data?.experience) formData.append('experience', action.payload.data?.experience);
            if (resType !== 'string' && action.payload.data?.resume)
                formData.append('resume', action.payload.data?.resume);
            if (action.payload.data?.photo) formData.append('photo', action.payload.data?.photo);
            const res = yield MOCK.post('auth/user-profile/update', formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            });
            if (res.status === 200) {
                yield put(updateUserInformationSuccess());
                yield call(action.payload.callback());
            }
        }
    } catch (e) {
        yield put(updateUserInformationFailure());
        handleError(e);
    }
}
const handleFileUpload = async (token) => {
    const baseURL = generateUrl('mock-interview-dev2');
    try {
        const response = await fetch(`${baseURL}/resume-parser/fetch-resume-pdf`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        await response.json();
    } catch (error) {
        console.error('API Error:', error);
        console.error('Error message:', error.message);
    }
};
function* verifyPaymentRequest(action) {
    try {
        const res = yield MOCK.post(`payments/verify/${action?.payload?.orderId}`, action?.payload?.razorpayResponse);
        if (res.status === 200) {
            if (action?.payload?.boostAddOn) {
                yield call(handleFileUpload, getAccessToken);
            }
            yield put(verifyPaymentSuccess());
            yield call(action.payload.callback());
        }
    } catch (e) {
        yield put(verifyPaymentFailure());
        handleError(e);
    }
}
function* orderUpdateRequest(action) {
    try {
        const { status, orderId } = action.payload;
        const res = yield MOCK.get(`payments/order-update/${status}/${orderId}`);
        if (res.status === 200) yield put(orderUpdateSuccess());
    } catch (e) {
        yield put(orderUpdateFailure());
        handleError(e);
    }
}
function* getInterviewRequest(action) {
    const { search, page, pageSize, sort, filter = null, status } = action.payload;
    const isSearch = search ? `&search=${encodeURIComponent(search)}` : '';
    const isPageAndPageSize = page && pageSize ? `?page=${page}&pageSize=${pageSize}` : '';
    const isSort = filter?.sort ? `&sort=${filter.sort}` : sort ? `&sort=${sort}` : '';
    const formatDate = (date) => (date ? date.split('T')[0] : '');

    const isFilter = filter
        ? (filter.status ? `&status=${filter.status}` : status ? `&status=${encodeURIComponent(status)}` : '') +
          (filter.from
              ? filter.to
                  ? `&from=${formatDate(filter.from)}T00:00:00&to=${formatDate(filter.to)}T23:59:59`
                  : `&from=${formatDate(filter.from)}T00:00:00&to=3000-12-31T23:59:59`
              : filter.to
                ? `&from=2000-01-01T00:00:00&to=${formatDate(filter.to)}T23:59:59`
                : '') +
          (filter.qFrom
              ? filter.qTo
                  ? `&qFrom=${formatDate(filter.qFrom)}T00:00:00&qTo=${formatDate(filter.qTo)}T23:59:59`
                  : `&qFrom=${formatDate(filter.qFrom)}T00:00:00&qTo=3000-12-31T23:59:59`
              : filter.qTo
                ? `&qFrom=2000-01-01T00:00:00&qTo=${formatDate(filter.qTo)}T23:59:59`
                : '')
        : '';

    try {
        const res = yield MOCK.get(`interviews/get-interviews${isPageAndPageSize}${isSearch}${isFilter}${isSort}`);
        if (res.status === 200) yield put(getInterviewDetailsSuccess(res.data.result));
    } catch (e) {
        yield put(getInterviewDetailsFailure());
        handleError(e);
    }
}
function* fetchSkillsPositionRequest(action) {
    try {
        const res = yield MOCK.post('interviews/get-skills', action?.payload?.finalPayload);
        if (res.status === 200) {
            yield put(fetchSkillsPositionSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(fetchSkillsPositionFailure());
        handleError(e);
    }
}
function* fetchSkillsJDRequest(action) {
    try {
        const formData = new FormData();
        formData.append('jd', action.payload.jd);
        const res = yield MOCK.post('interviews/fetch-skills', formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
        if (res.status === 200) {
            yield put(fetchSkillsJDSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(fetchSkillsJDFailure());
        handleError(e);
    }
}
function* createInterviewRequest(action) {
    try {
        const { user, position, skills, seniority, codingTest, difficultyLevel, resume } =
            action?.payload?.finalPayload;

        const formData = new FormData();
        formData.append('user', user);
        formData.append('position', position);
        formData.append('skills', JSON.stringify(skills));
        formData.append('seniority', seniority);
        formData.append('codingTest', codingTest);
        formData.append('difficultyLevel', difficultyLevel);

        if (resume) {
            formData.append('resume', resume);
        }

        const res = yield MOCK.post('interviews/create-interview', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (res.status === 200) {
            yield put(createInterviewSuccess());
            yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(createInterviewFailure());
        handleError(e);
    }
}

function* replicateInterviewRequest(action) {
    try {
        const res = yield MOCK.post('interviews/replicate-interview', action?.payload?.data);
        if (res.status === 200) {
            yield put(replicateInterviewSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(replicateInterviewFailure());
        handleError(e);
    }
}
function* fetchResumeScoreRequest(action) {
    try {
        const formData = new FormData();
        formData.append('jd', action.payload.jd);
        formData.append('cv', action.payload.cv);
        const res = yield MOCK.post('interviews/compare-jd-to-cv', formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
        if (res.status === 200) {
            yield put(fetchResumeScoreSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(fetchResumeScoreFailure());
        handleError(e);
    }
}
function* postCheckoutRequest(action) {
    try {
        const res = yield MOCK.post('payments/checkout', action?.payload?.finalPayload);
        if (res.status === 200) {
            yield put(postCheckoutSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(postCheckoutFailure());
        handleError(e);
    }
}
function* applyCouponRequest(action) {
    try {
        const res = yield MOCK.post('payments/applyCoupon', { couponCode: action?.payload?.couponCode });
        if (res.status === 200) {
            yield put(applyCouponSuccess());
            if (action.payload.callback && res.data?.result) yield call(action.payload.callback, res.data?.result);
        }
    } catch (e) {
        yield put(applyCouponFailure());
    }
}

function* getBannersRequest() {
    try {
        const res = yield MOCK.get('interviews/banner');
        if (res.status === 201 || res.status === 200) {
            yield put(getBannersSuccess(res.data));
        } else yield put(getBannersFailure());
    } catch (e) {
        yield put(getBannersFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetDashboardDetailsAPI() {
    yield takeEvery(GET_DASHBOARD_DETAILS, getDashboardDetailsRequest);
}
export function* watchGetNotificationAPI() {
    yield takeEvery(GET_NOTIFICATION_LIST, getNotificationRequest);
}
export function* watchReadNotificationAPI() {
    yield takeEvery(READ_NOTIFICATION_LIST, readNotificationRequest);
}
export function* watchClearNotificationAPI() {
    yield takeEvery(CLEAR_NOTIFICATION_LIST, clearNotificationRequest);
}
export function* watchGetInterviewAPI() {
    yield takeEvery(GET_INTERVIEW_DETAILS, getInterviewRequest);
}
export function* watchFetchResumeScoreAPI() {
    yield takeEvery(FETCH_RESUME_SCORE, fetchResumeScoreRequest);
}
export function* watchResendEmailAPI() {
    yield takeEvery(RESEND_EMAIL, resendEmailRequest);
}
export function* watchLogoutUserAPI() {
    yield takeEvery(LOGOUT_USER, logoutUserRequest);
}
export function* watchChangePasswordAPI() {
    yield takeEvery(CHANGE_PASSWORD, changePasswordRequest);
}
export function* watchGetPlansAndPricingListAPI() {
    yield takeEvery(GET_PLANS_AND_PRICING, getPlansAndPricingListRequest);
}
export function* watchGetBillingInformation() {
    yield takeEvery(GET_BILLING_INFORMATION, getBillingInformationRequest);
}
export function* watchGetPositionListAPI() {
    yield takeEvery(GET_POSITION_LIST, getPositionListRequest);
}
export function* watchGetMandatorySkillAPI() {
    yield takeEvery(GET_MANDATORY_SKILL, getMandatorySkillRequest);
}
export function* watchSupportRequestAPI() {
    yield takeEvery(SUPPORT_REQUEST, supportRequest);
}
export function* watchGetSupportTicketsAPI() {
    yield takeEvery(GET_SUPPORT_TICKET, getSupportTicketsRequest);
}
export function* watchCloseSupportTicketsAPI() {
    yield takeEvery(CLOSE_SUPPORT_TICKET, closeSupportTicketRequest);
}
export function* watchGetUserInformationAPI() {
    yield takeEvery(GET_USER_INFORMATION, getUserInformationRequest);
}
export function* watchUpdateUserInformationAPI() {
    yield takeEvery(UPDATE_USER_INFORMATION, updateUserInformationRequest);
}
export function* watchFetchSkillsPositionAPI() {
    yield takeEvery(FETCH_SKILLS_POSITION, fetchSkillsPositionRequest);
}
export function* watchFetchSkillsJDAPI() {
    yield takeEvery(FETCH_SKILLS_JD, fetchSkillsJDRequest);
}
export function* watchPostCheckoutAPI() {
    yield takeEvery(POST_CHECKOUT, postCheckoutRequest);
}
export function* watchOrderUpdateAPI() {
    yield takeEvery(ORDER_UPDATE, orderUpdateRequest);
}
export function* watchCreateInterviewAPI() {
    yield takeEvery(CREATE_INTERVIEW, createInterviewRequest);
}
export function* watchReplicateInterviewAPI() {
    yield takeEvery(REPLICATE_INTERVIEW, replicateInterviewRequest);
}
export function* watchVerifyPaymentAPI() {
    yield takeEvery(VERIFY_PAYMENT, verifyPaymentRequest);
}
export function* watchApplyCouponAPI() {
    yield takeEvery(APPLY_COUPON, applyCouponRequest);
}
export function* watchGetBannersAPI() {
    yield takeEvery(GET_BANNERS, getBannersRequest);
}
export default function* rootSaga() {
    yield all([
        watchGetDashboardDetailsAPI(),
        watchGetNotificationAPI(),
        watchReadNotificationAPI(),
        watchClearNotificationAPI(),
        watchGetInterviewAPI(),
        watchFetchResumeScoreAPI(),
        watchResendEmailAPI(),
        watchChangePasswordAPI(),
        watchLogoutUserAPI(),
        watchGetPlansAndPricingListAPI(),
        watchGetBillingInformation(),
        watchGetPositionListAPI(),
        watchGetMandatorySkillAPI(),
        watchSupportRequestAPI(),
        watchGetSupportTicketsAPI(),
        watchCloseSupportTicketsAPI(),
        watchGetUserInformationAPI(),
        watchUpdateUserInformationAPI(),
        watchFetchSkillsPositionAPI(),
        watchFetchSkillsJDAPI(),
        watchPostCheckoutAPI(),
        watchOrderUpdateAPI(),
        watchCreateInterviewAPI(),
        watchReplicateInterviewAPI(),
        watchVerifyPaymentAPI(),
        watchApplyCouponAPI(),
        watchGetBannersAPI(),
    ]);
}
